export default function CalendarCell(props) {
    return <div className='calendar__cell'>{props.children}</div>;
}
